import {LOCATION_CHANGE} from 'react-router-redux'
import {status, discardStatus} from '../core/redux/status'
import extract from '../core/extract'
import {ACTION_FAILED} from './actions'
import i18n from './i18n'

export function thunk(store) {
    return (next) => (action) => {
        if (typeof action == 'function') {
            return next(action(store.getState(), store))
        }
        return next(action)
    }
}

export function promise() {
    return (next) => (action) => {
        if (typeof action.then == 'function') {
            return Promise.resolve(action).catch((error) => {
                return Promise.reject(next({
                    type: ACTION_FAILED,
                    error: error
                }).error)
            }).then((action) => {
                return next(action)
            })
        }
        return next(action)
    }
}

export function worker() {
    return (next) => {

        function messageEventListener(event) {
            if (event.data.error) {
                next({
                    type: ACTION_FAILED,
                    error: event.data.error
                })
            }
        }

        function errorEventListener(event) {
            next({
                type: ACTION_FAILED,
                error: {message: event.message}
            })
        }

        return (action) => {
            if (typeof action.addEventListener == 'function') { 
                const worker = action

                worker.addEventListener('message', messageEventListener)
                worker.addEventListener('error', errorEventListener)

                // break middleware chain
                return worker
            }
            return next(action)
        }
    }
}

export function errorStatus(errorTypeMessage) {
    return ({dispatch, getState}) => {

        function statusType(error) {
            if (error.statusCode == 401) return 'info'
            if (error.statusCode >= 400) return 'danger'
            if (error.statusCode >= 200) return 'info'
            return 'danger'
        }

        function statusMessage(error) {
            if (error.type) return errorTypeMessage(error, getState)
            if (error.statusCode) return extract(i18n.errorStatusCodeEnum, error.statusCode)
            return i18n.systemError
        }

        return (next) => (action) => {
            if (action.type == ACTION_FAILED) {
                if (action.error && action.error.statusCode) {
                    // functional error
                    const error = action.error
                    dispatch(status(statusType(error), statusMessage(error)))
                }
                return next(action)
            }
            if (action.type == LOCATION_CHANGE) {
                const state = getState()

                if (state.status && action.payload.action != 'REPLACE') {
                    dispatch(discardStatus())
                }
                return next(action)
            }
            return next(action)
        }
    }
}

export function error() {
    return (next) => (action) => {
        if (action.type == ACTION_FAILED) {

            if (action.error == 'TypeError: Network request failed') {
                // IE 10 bug. We get this error when server returns a 401
                // https://connect.microsoft.com/IE/feedback/details/785990/ie-10-on-win8-does-not-assign-the-correct-status-to-xmlhttprequest-when-the-result-is-401
                action.error = {
                    statusCode: 401,
                    name: 'UnauthorizedError'
                }
            }

            if (action.error && action.error.name == 'TypeMismatchError') {
                // IE Edge bug. We get this error when server returns a 401
                // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/8653298/
                action.error = {
                    statusCode: 401,
                    name: 'UnauthorizedError'
                }
            }

            if (action.error == 'TypeError: Failed to fetch') {
                // most likely a timeout occured
                action.error = {
                    statusCode: 500,
                    name: 'ServerError'
                }
            }

            if (action.error && action.error.statusCode) {
                // functional error
                console && console.warn(action.error.name + ': ' + action.error.message)
            }

            return next(action)
        }

        return next(action)
    }
}


// WEBPACK FOOTER //
// ./lib/app/middlewares.js